import type { GameState } from './types';

export const gameInitialState: GameState = {
  loading: false,
  error: null,
  currentGame: null,
  players: [''],
};
